<template>
  <container class="brand">
    <v-row class="header-container">
      <v-col cols="12" md="4" lg="3">
        <v-card-title>Marcas</v-card-title>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn @click="getBrands()" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-text-field
          v-model="filter"
          label="Buscar Marca"
          prepend-icon="mdi-magnify"
          @keyup.enter="getBrands"
          :disable="loading"
          clearable
          single-line
          v-if="filter !== null"
          @click:clear="handleClearFilter"
        ></v-text-field>
        <v-btn v-else @click="filter = ''" icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-right">
        <v-btn @click="handleOpenDialog()" color="primary">
          <v-icon left>mdi-plus</v-icon>Nova Marca
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="5"
          :disable="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loading-text="A carregar..."
        >
          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="handleEditBrand(item.id)">
                    <v-icon left size="20">mdi-pencil</v-icon>
                    <v-list-item-title>Alterar</v-list-item-title>
                  </v-list-item>
                  <v-list-item value="true" @click="handleRemoveBrand(item)">
                    <v-icon left size="20">mdi-delete</v-icon>
                    <v-list-item-title>Remover</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>

        <v-dialog v-model="brand_dialog" max-width="500" persistent>
          <BrandForm
            v-model="brand"
            title="Dados da marca"
            @submit="handleSubmitForm"
            @close="handleCloseBrandDialog"
            :brand_id="edit_brand"
          ></BrandForm>
        </v-dialog>

        <v-dialog v-model="confirm_dialog" max-width="300" persistent>
          <v-card>
            <v-card-title>
              Remover marca?
              <v-spacer></v-spacer>
              <v-btn @click="confirm_dialog = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disable="loading_deleting"
                text
                @click="confirm_dialog = false"
                >Não</v-btn
              >
              <v-btn
                :disable="loading_deleting"
                color="red"
                dark
                @click="removeBrand()"
                >Remover</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </container>
</template>

<script>
import {
  index as indexBrands,
  show as showBrands,
  update as updateBrands,
  destroy as deleteBrands,
} from "../services/brands";
import BrandForm from "../components/forms/BrandForm";

export default {
  components: { BrandForm },
  data: () => ({
    items: [],
    headers: [
      { text: "Nome", value: "name" },
      { text: "Canonical", value: "canonical" },
      { text: "Acções", value: "actions", sortable: false },
    ],
    filter: null,
    loading: false,
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      sortBy: ["name"],
      sortDesc: [],
    },
    brand_dialog: false,
    brand: {},
    confirm_dialog: false,
    confirm_brand: null,
    loading_deleting: false,
    edit_brand: null,
  }),
  methods: {
    handleCloseBrandDialog() {
      this.brand_dialog = false;
      this.edit_brand = null;
    },
    handleEditBrand(brand_id) {
      this.edit_brand = brand_id;
      this.brand_dialog = true;
    },
    handleClearFilter() {
      this.filter = null;
      this.getBrands();
    },
    async removeBrand() {
      this.loading_deleting = true;

      try {
        await deleteBrands(this.confirm_brand.id);
        this.items = this.items.filter(
          (item) => item.id !== this.confirm_brand.id
        );
        this.$store.commit("sendMessage", {
          text: "Marca excluída com sucesso",
        });
        this.confirm_dialog = false;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível excluir a marca",
          red: "red",
        });
      } finally {
        this.loading_deleting = false;
      }
    },
    async getBrands() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loading = true;
      this.items = [];

      const response = await indexBrands({
        sortBy,
        sortDesc,
        page,
        itemsPerPage,
        filter: this.filter || "",
      });

      this.items = response.data;
      this.loading = false;
      this.totalItems = response.total;
    },
    handleSubmitForm(event) {
      this.getBrands();
      this.handleCloseBrandDialog();
    },
    handleOpenDialog() {
      this.brand_dialog = true;
    },
    handleCloseDialog() {
      this.brand_dialog = false;
    },
    handleRemoveBrand(brand) {
      this.confirm_dialog = true;
      this.confirm_brand = brand;
    },
  },
  created() {
    this.getBrands();
  },
  watch: {
    options: {
      handler() {
        this.getBrands();
      },
      deep: true,
    },
  },
};
</script>